// src/design-system/components/Select/Select.tsx
import React from 'react';

interface SelectOption {
  value: string | number;
  label: string;
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options?: SelectOption[];
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  error?: boolean;
  className?: string;
}

/**
 * 🔴 13.09.2026 (site gezisinde bulundu): bileşen yalnız `options` dizisini
 * çiziyor, içine yazılan `<option>` çocuklarını ATIYORDU. Kullanan her ekran
 * çocuk yazıyor → İrsaliye'de müşteri ve birim, Vade Hatırlatmaları'nda durum,
 * tip ve öncelik kutuları BOŞTU; kayıt açılamıyordu.
 * Ayrıca `className` dış kaba veriliyordu (CSS modülünde o sınıflar hiç yoktu):
 * ekranda kutu içinde küçük, boş bir ikinci kutu görünüyordu.
 * Şimdi: çocuk varsa o, yoksa `options` çizilir; sınıf doğrudan select'e gider.
 */
const Select: React.FC<SelectProps> = ({
  options = [],
  value,
  onChange,
  placeholder,
  disabled = false,
  error = false,
  className = '',
  children,
  style,
  ...props
}) => {
  const cocukVar = React.Children.count(children) > 0;
  return (
    <select
      className={`${className}${error ? ' is-error' : ''}`}
      style={{ width: '100%', ...style }}
      value={value}
      onChange={onChange}
      disabled={disabled}
      aria-invalid={error || undefined}
      {...props}
    >
      {cocukVar ? children : (
        <>
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </>
      )}
    </select>
  );
};

export default Select;
